import { useUpdate } from '../../../../../hooks'

// Hook used for reloading filter values and sync with table filter state.
// Loading filters by `loadFilterBarData` is only way to get actual filter state after applying actions.
// For example, set filter by name and archive entity, then we must update filter values and API for
// filter state won't give us new filters value without archived.
//
// It's seems very `spaghetti` and possibly need's to discuss with backend to solve this updates chain.
export function useFilterBarReload({
  handleApply,
  loadFilterBarData,
  shouldReloadValues,
  onChangeShouldReloadValues,
  onReload,
}) {
  useUpdate(() => {
    if (shouldReloadValues) {
      onChangeShouldReloadValues(false)

      // Call every single field api to get next options
      loadFilterBarData().then(nextOptions => {
        // if there are updated options then we set it to filter values
        // if not we just reload table page
        if (nextOptions) {
          handleApply(nextOptions)
        } else {
          onReload?.()
        }
      })
    }
  }, [shouldReloadValues])
}
